<span>
    <img [ngbTooltip]="partner?.name" [disableTooltip]="!onlyIcon" src="{{ partner?.iconPath }}" alt="{{ partner?.name }}" height="{{ size }}" />
    <span *ngIf="!onlyIcon" class="pl-1">{{ partner?.name }}</span>
</span>
